

function CardCustomerStory({ item, className, ...props }){
  return <div
    {...props}
    className={`
      pt-44u
      px-40u
      rounded-30u
      focus:outline-none
      border-3u border-[#A9AAB5]
      bg-[#0E2242]
      flex flex-col h-full
    ${className}
    `}
  >
        <div className='w-full h-[15.25rem] bg-white rounded-20u border-3u border-[#A9AAB5]
        py-32u px-78u
        flex items-center justify-center overflow-hidden'>
            <img className='max-h-full max-w-full object-contain'
        src={`${process.env.PUBLIC_URL}/logos/${item.logo}`} />
        </div>
      

      <div className='w-full mt-52u font-light text-48u leading-62u px-35u'>{item.title}</div>
      <div className='w-full mt-32u font-light text-24u leading-42u px-35u'>{item.description}</div>
      <div className='w-[calc(100%+40u)] mt-auto h-193u flex flex-row items-center border-t-3u border-[#A9AAB5] -mx-40u pl-40u'>
        <div>
            <img
                src={`${process.env.PUBLIC_URL}/qr/${item.qr}`}
                alt={item.qr_title}
                className="w-120u h-120u object-cover rounded-10u"
            /> 
        </div>
        <div className="ml-22u text-32u">Scan to view the case study</div>
    </div>
    
  </div>;
};

export default CardCustomerStory;